<template>
	<v-row>
		<v-col :cols="colSize" class="text-center" v-if="colSize == 3">
			<br/>
			<v-icon>mdi-poll</v-icon>Aktuelle Beteiligungsdaten
		</v-col>
		<v-col :cols="colSize" class="text-center">
			<span class="collab-stat-n">
				<ProgressCircle color="green" :value="getPercentage(complete)"></ProgressCircle>
			</span>
			<small class="collab-label">{{mwTranslate('status', 'complete')}}</small>
		</v-col>
		<v-col :cols="colSize" class="text-center">
			<span class="collab-stat-n">
				<ProgressCircle color="yellow" :value="getPercentage(incomplete)"></ProgressCircle>
			</span>
			<small class="collab-label">{{mwTranslate('status', 'incomplete')}}</small>
		</v-col>
		<v-col :cols="colSize" class="text-center">
			<span class="collab-stat-n">
				<ProgressCircle color="red" :value="getPercentage(pending)"></ProgressCircle>
			</span>
			<small class="collab-label"> {{mwTranslate('status', 'pending')}} </small>
		</v-col>
	</v-row>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import ProgressCircle from "@/components/elements/ProgressCircle"
	export default {
		name: "PollStats", 
		props: {
			id: {type: String}, 
			title: {type: Boolean, default: true }
		},
		data: () => {
			return {

			}
		},
		components: {
			ProgressCircle
		},
		computed: {
			...Vuex.mapState({
				collaborations: state => state.collaborations || [],
				groups: state => state.groups || [], 
				users: state => state.users || []
			}),
			isMobile(){
				return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs)
			},
			colSize(){
				if( this.title && !this.isMobile ){
					return 3;
				}
				return 4;
			},
			collaboration(){
				var id = this.id;
				return this.collaborations.find( c => c.id == id )
			}, 
			collabGroups(){
				var members = this.collaboration.members;
				return this.groups.filter( g => members.indexOf(g.id) > -1 )
			},
			collabMembers(){
				var groups_members = this.collabGroups.flatMap( group => group.members );
				var user_members = this.collaboration.members.filter ( id => this.collabGroups.map( group => group.id ).indexOf(id ) < 0 );
				var members = groups_members.concat( user_members )
				return this.users.filter( u => members.indexOf(u.id) > -1 )
			},
			complete(){
				return this.collaboration.response_count;
			},
			incomplete(){
				return this.collaboration.started_count;
			},
			pending(){
				return this.collabMembers.length - (this.complete + this.incomplete )
			}
		},
		methods: {
			getPercentage(v){
				return Math.floor(v / this.collabMembers.length * 100)  
			}
		}
		// created(){
			
		// }

	}
</script>